import React from 'react';

const useDefaultedEvent = (defaultHandler, customHandler) => {
  return React.useCallback((e) => {
    if (customHandler) {
      customHandler(e);
      if (e.defaultPrevented) return;
    }
    defaultHandler(e);
  }, [
    defaultHandler,
    customHandler
  ]);
};

export { useDefaultedEvent };
//# sourceMappingURL=useDefaultedEvent.js.map
